export default __webpack_public_path__ + "static/media/Armbands of the Oxmal.b5852f10.jpg";